import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography, Divider } from '@mui/material';
import { useTranslation } from "react-i18next";
import ArrowDropDown from '@mui/icons-material/KeyboardArrowDown';

const FilterButtons = ({ filterData, period, setPeriod }) => {
  const [activeFilter, setActiveFilter] = useState(period);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t, i18n } = useTranslation();

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    setPeriod(filter);
    filterData(filter);
    setAnchorEl(null);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box border={1} borderColor="#455a64" padding="2px" borderRadius={2} display="flex" alignItems="center">
      <Typography variant="h6" marginLeft="5px" marginRight="5px" sx={{fontSize:"10px"}}>{t('prod_winder_machine.period')} </Typography>
      <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
      <div>
        <Button size='small' color="secondary" aria-controls="filter-menu" aria-haspopup="true" onClick={handleMenuOpen} className="dropdown-toggle" endIcon={<ArrowDropDown />} >          {activeFilter}        </Button>
        <Menu size="small" id="filter-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}        >
          <MenuItem onClick={() => handleFilterClick('All')} className={activeFilter === 'All' ? 'active' : ''}>All</MenuItem>
          <MenuItem onClick={() => handleFilterClick('Today')} className={activeFilter === 'Today' ? 'active' : ''}>Today</MenuItem>
          <MenuItem onClick={() => handleFilterClick('This Week')} className={activeFilter === 'This Week' ? 'active' : ''}>This Week</MenuItem>
          <MenuItem onClick={() => handleFilterClick('This Month')} className={activeFilter === 'This Month' ? 'active' : ''}>This Month</MenuItem>
          <MenuItem onClick={() => handleFilterClick('This Quarter')} className={activeFilter === 'This Quarter' ? 'active' : ''}>This Quarter</MenuItem>
          <MenuItem onClick={() => handleFilterClick('This Year')} className={activeFilter === 'This Year' ? 'active' : ''}>This Year</MenuItem>
        </Menu>
      </div>
    </Box>
  );
};

export default FilterButtons;
